<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    title="使用模板批量创建"
    @close="handleClose"
  >
    <template-item layout="flex" label="题目类型"
      ><el-radio-group v-model="titleType">
        <el-radio :label="1">地区</el-radio>
        <el-radio :label="2">日期</el-radio>
        <el-radio :label="3">时间</el-radio>
        <el-radio :label="4">性别</el-radio>
        <el-radio :label="5">货币</el-radio>
        <el-radio :label="null">其他</el-radio>
      </el-radio-group>
    </template-item>
    <template-item label="填写方向"
      ><el-radio-group v-model="valueDirection">
        <el-radio :label="1">向下</el-radio>
        <el-radio :label="2">向右</el-radio>
      </el-radio-group>
    </template-item>
    <designer-template-area
      v-if="titleType === 1"
      :direction="valueDirection"
    />
    <!--    <el-tabs v-model="tabName">-->
    <!--      <el-tab-pane label="地区" name="area">-->
    <!--        <designer-template-area :direction="1" />-->
    <!--      </el-tab-pane>-->
    <!--      <el-tab-pane label="日期" name="date">日期模板</el-tab-pane>-->
    <!--      <el-tab-pane label="时间" name="time">时间模板</el-tab-pane>-->
    <!--    </el-tabs>-->
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click.stop="handleClose">取 消</el-button>
      <el-button size="mini" type="primary" @click.stop="handleOk"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { Tabs, TabPane, Button } from "element-ui";
import { Dialog, MessageBox } from "element-ui";
import { RadioGroup, Radio } from "element-ui";
import DesignerTemplateArea from "./area/index";
import TemplateItem from "@/components/excel/designer/template/TemplateItem";

export default {
  name: "designer-template",
  components: {
    TemplateItem,
    DesignerTemplateArea,
    [Dialog.name]: Dialog,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
  },
  props: {
    visible: {
      type: Boolean,
    },
  },
  data() {
    return {
      tabName: "area",
      titleType: 1,
      // visibleProxy: false,
      valueDirection: 1,
    };
  },
  computed: {
    visibleProxy: {
      get() {
        return this.$props.visible;
      },
      set(value) {
        console.log("准备触发事件");
        this.$emit("update:visible", value);
      },
    },
  },
  // watch: {
  //   // visible(value) {
  //   //   this.visibleProxy = value;
  //   // },
  //   visibleProxy(value) {
  //     console.log('准备触发事件');
  //     this.$emit("update:visible", value);
  //   }
  // },
  // mounted(){
  //   this.visibleProxy = this.$props.visible;
  // },
  methods: {
    handleClose(done) {
      if (!this.$props.visible) {
        // 点确定之后 关闭 改变了visible 也会触发这个事件
        return;
      }
      MessageBox.confirm("确认关闭？")
        .then((_) => {
          this.$emit("update:visible", false);
          done();
        })
        .catch((_) => {});
    },
    handleOk() {
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style scoped>
div >>> .el-dialog > .el-dialog__body {
  padding: 0 20px;
}
div >>> .template-label {
  width: 100px;
  display: inline-block;
}
div >>> .template-item-wrapper {
  padding: 5px 0;
}
</style>
